import React, {Component} from 'react';

function TotalArt({ numart }) {
    return (
        <div>
            ElementTotal: <a href="http://www.whiteheadgallery.io/add_element.php" target="new">{numart}</a><br/>
        </div>
    );
}
export default TotalArt;